import React from "react";
import { axiosget, axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import states_lga from "./state_lga.json";
import Loader from "../../components/Loader";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ErrorResponse from "../../components/ErrorResponse";
import { Form, Formik } from "formik";
import { ms_applicant } from "@v2/validators";
import ErrorMessage from "../../components/ErrorMessage";
import PageTitle from "../../components/PageTitle";
import SelectField from "../../components/SelectField";

const BioData = () => {
  const queryClient = useQueryClient();
  const states = states_lga.map((v) => ({ label: v.state, value: v.state })).sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
  const [lgaofresidence, setlgaofresidence] = React.useState("");
  const [lgaoriginlist, setlgaoriginlist] = React.useState("");
  const [lgaresidencelist, setlgaresidencelist] = React.useState("");

  const { isLoading, error, data } = useQuery({
    queryKey: ["bioDataLoaded"],
    queryFn: async () => {
      const req = await axiosget("ms_applicant/bio");
      return req?.data;
    },
  });
  const _login = async (values) => {
    try {
      const req = await axiospost("ms_applicant/bio", {
        firstname: values?.firstname,
        middlename: values?.middlename,
        lastname: values?.lastname,
        gender: values?.gender,
        religion: values?.religion,
        dateofbirth: values?.dateofbirth,
        qualification: values?.qualification,
        maritalstatus: values?.maritalstatus,
        emailaddress: values?.emailaddress,
        phonenumber: values?.phonenumber,
        homeaddress: values?.homeaddress,
        stateoforigin: values?.stateoforigin,
        stateofresidence: values?.stateofresidence,
        lgaoforigin: values?.lgaoforigin,
        lgaofresidence: values?.lgaofresidence,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data } = req;
      if (data && data.type === "success") {
        const { message, type } = data;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["bioDataLoaded"] });
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  return (
    <>
      <PageTitle title={"BIO DATA"} sub={`UPDATE YOUR BIO-DATA`} />
      {isLoading && <Loader />}
      {error || (data?.message && <ErrorResponse type={"danger"} message={error?.message ? error?.message : data?.message} />)}
      {data?.message === undefined && (
        <Formik
          enableReinitialize={true}
          initialValues={{
            firstname: data ? data?.firstname : "",
            middlename: data ? data?.middlename : "",
            lastname: data ? data?.lastname : "",
            gender: data ? data?.gender : "",
            religion: data ? data?.religion : "",
            display: data ? data?.display : "",
            qualification: data ? data?.qualification : "",
            maritalstatus: data ? data?.maritalstatus : "",
            emailaddress: data ? data?.emailaddress : "",
            phonenumber: data ? data?.phonenumber : "",
            homeaddress: data ? data?.homeaddress : "",
            stateoforigin: data ? data?.stateoforigin : "",
            stateofresidence: data ? data?.stateofresidence : "",
            lgaoforigin: data ? data?.lgaoforigin : "",
            lgaofresidence: data ? data?.lgaofresidence : "",
            dateofbirth: data ? String(data?.dateofbirth).split("T")[0] : "",
          }}
          validationSchema={ms_applicant.createapplicantbiorules}
          initialTouched={{ zip: true }}
          onSubmit={_login}
        >
          {({ isSubmitting, touched, errors, setFieldValue }) => (
            <Form className="my-3">
              <div className="row">
                <div className="col-md-4">
                  <ErrorMessage
                    name={"firstname"}
                    label="First Name"
                    type="text"
                    key={`error_firstname`}
                    errors={errors?.firstname}
                    touched={touched?.firstname}
                  />
                </div>
                <div className="col-md-4">
                  <ErrorMessage
                    name={"middlename"}
                    label="Middle Name"
                    type="text"
                    key={`error_middlename`}
                    errors={errors?.middlename}
                    touched={touched?.middlename}
                  />
                </div>
                <div className="col-md-4">
                  <ErrorMessage
                    name={"lastname"}
                    label="Last Name"
                    type="text"
                    key={`error_lastname`}
                    errors={errors?.lastname}
                    touched={touched?.lastname}
                  />
                </div>
                <div className="col-md-6 my-3">
                  <SelectField
                    name="stateoforigin"
                    label="State of Origin"
                    errors={errors.stateoforigin}
                    touched={touched.stateoforigin}
                    onChange={(event) => {
                      setFieldValue("stateoforigin", event.value);
                      const stateObj = states_lga?.filter((state) => state.state === event.value).shift();
                      setlgaoriginlist(stateObj?.lgas);
                    }}
                    options={states}
                  />
                </div>
                <div className="col-md-6 my-3">
                  {lgaoriginlist && (
                    <SelectField
                      name="lgaoforigin"
                      label="LGA of Origin"
                      errors={errors.lgaoforigin}
                      touched={touched.lgaoforigin}
                      onChange={(event) => setFieldValue("lgaoforigin", event.value)}
                      options={lgaoriginlist?.map((r) => ({ label: r, value: r }))}
                    />
                  )}
                </div>

                <div className="col-md-6 my-3">
                  {states && (
                    <SelectField
                      name="stateofresidence"
                      label="State of Residence"
                      errors={errors.stateofresidence}
                      touched={touched.stateofresidence}
                      onChange={(event) => {
                        setFieldValue("stateofresidence", event.value);
                        const stateObj = states_lga?.filter((state) => state.state === event.value).shift();
                        setlgaresidencelist(stateObj?.lgas);
                      }}
                      options={states}
                    />
                  )}
                </div>
                <div className="col-md-6 my-3">
                  {lgaresidencelist && (
                    <SelectField
                      name={"lgaofresidence"}
                      key={`error_lgaofresidence`}
                      errors={errors?.lgaofresidence}
                      touched={touched?.lgaofresidence}
                      onChange={(event) => setFieldValue("lgaofresidence", event.value)}
                      options={lgaresidencelist?.map((r) => ({ label: r, value: r }))}
                      label="Select Local Gov. Area of Residence"
                      active={lgaofresidence ? lgaofresidence : data?.lgaofresidence}
                      callback={setlgaofresidence}
                    />
                  )}
                </div>
                <div className="col-md-6 my-3">
                  <SelectField
                    name={"gender"}
                    key={`error_gender`}
                    onChange={(event) => setFieldValue("gender", event.value)}
                    errors={errors?.gender}
                    touched={touched?.gender}
                    options={[
                      { label: "Male", value: "Male" },
                      { label: "Female", value: "Female" },
                    ]}
                    label="Select Gender"
                  />
                </div>
                <div className="col-md-6 my-3">
                  <SelectField
                    name={"religion"}
                    key={`error_religion`}
                    onChange={(event) => setFieldValue("religion", event.value)}
                    errors={errors?.religion}
                    touched={touched?.religion}
                    options={[
                      { label: "Muslim", value: "Muslim" },
                      { label: "Christain", value: "Christain" },
                      { label: "Others", value: "Others" },
                    ]}
                    label="Select Religion"
                  />
                </div>

                <div className="col-md-4">
                  <ErrorMessage
                    name={"dateofbirth"}
                    label="Date of Birth"
                    type="date"
                    key={`error_dateofbirth`}
                    errors={errors?.dateofbirth}
                    touched={touched?.dateofbirth}
                  />
                </div>
                <div className="col-md-4">
                  <SelectField
                    name={"qualification"}
                    key={`error_qualification`}
                    onChange={(event) => setFieldValue("qualification", event.value)}
                    errors={errors?.qualification}
                    touched={touched?.qualification}
                    options={[
                      {
                        label: "Primary School Certificate",
                        value: "Primary School Certificate",
                      },
                      {
                        label: "Secondary/O-Level Certificate",
                        value: "Secondary/O-Level Certificate",
                      },
                      {
                        label: "National Diploma (ND)",
                        value: "National Diploma (ND)",
                      },
                      {
                        label: "Nigeria Certificate in Education (NCE)",
                        value: "Nigeria Certificate in Education (NCE)",
                      },
                      {
                        label: "Higher National Diploma (HND)",
                        value: "Higher National Diploma (HND)",
                      },
                      {
                        label: "University Degree",
                        value: "University Degree",
                      },
                      {
                        label: "Masters Degree",
                        value: "Masters Degree",
                      },
                      {
                        label: "PhD. Degree",
                        value: "PhD. Degree",
                      },
                    ]}
                    label="Select Highest Qualification"
                  />
                </div>
                <div className="col-md-4">
                  <SelectField
                    name={"maritalstatus"}
                    key={`error_maritalstatus`}
                    onChange={(event) => setFieldValue("maritalstatus", event.value)}
                    errors={errors?.maritalstatus}
                    touched={touched?.maritalstatus}
                    options={[
                      { label: "Single", value: "Single" },
                      { label: "Married", value: "Married" },
                      { label: "Divorced", value: "Divorced" },
                      { label: "Widowed", value: "Widowed" },
                    ]}
                    label="Select Marital Status"
                  />
                </div>
                <div className="col-md-6">
                  <ErrorMessage
                    name={"emailaddress"}
                    label="Email Address"
                    type="email"
                    key={`error_emailaddress`}
                    errors={errors?.emailaddress}
                    touched={touched?.emailaddress}
                  />
                </div>
                <div className="col-md-6">
                  <ErrorMessage
                    name={"phonenumber"}
                    label="Phone Number (23480xxxxxxxx)"
                    type="text"
                    key={`error_phonenumber`}
                    errors={errors?.phonenumber}
                    touched={touched?.phonenumber}
                  />
                </div>

                <div className="col-md-12">
                  <ErrorMessage
                    name={"homeaddress"}
                    label="Contact Address"
                    type="text"
                    key={`error_homeaddress`}
                    errors={errors?.homeaddress}
                    touched={touched?.homeaddress}
                  />
                </div>
                <div className="mt-1">
                  <button type="submit" disabled={isSubmitting} className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                    {isSubmitting ? "Please wait..." : "Save data"}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default BioData;
